import { render, staticRenderFns } from "./accurate-grade.vue?vue&type=template&id=271d00f8&scoped=true"
import script from "./accurate-grade.vue?vue&type=script&lang=js"
export * from "./accurate-grade.vue?vue&type=script&lang=js"
import style0 from "./accurate-grade.vue?vue&type=style&index=0&id=271d00f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d00f8",
  null
  
)

export default component.exports